module.exports = __webpack_public_path__ + "static/media/unholy_wand.ca0c7adb.png";